module.exports = __webpack_public_path__ + "img/30.827745cd.jpg";